import React from "react";
import "./content-footer.css";

export default function ContentFooterTemplate({ block }) {
  const {
    title,
    text,
    backgroundUrl,
    ctaLabel,
    ctaUrl,
    clipPath = false,
    elementClass = "",
  } = block;
  return (
    <div
      className={[
        "content-footer",
        elementClass,
      ].join(" ").trim()}
    >
      <div
        className={[
          "content-footer-inner",
          "d-flex",
          "flex-wrap"
        ].join(" ").trim()}
      >
        {backgroundUrl && (
          <div
            className={[
              "content-footer-media",
              clipPath ? "has-clip-path" : "",
            ].join(" ")}
            style={{ backgroundImage: `url(${backgroundUrl})` }}
          />
        )}

        <div className="content-footer-content">
          {title && (
            <div className="cms-block-title">
              <h2>
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </h2>
            </div>
          )}

          {text && (
            <div
              className="cms-block-text"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}

          {ctaLabel && ctaUrl && (
            <div className="mt-4">
              <a href={ctaUrl} className="btn btn-secondary rounded-pill">
                {ctaLabel}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
